import type { Guide } from "./guide";
import { APPROVALS } from "./approvals";
import { EVENTS_AND_WEBHOOKS } from "./events-and-webhooks";
import { GOING_LIVE } from "./going-live";
import { INSIDE_YOUR_APP } from "./inside-your-app";
import { MANY_CUSTOMERS } from "./many-customers";
import { ROUTINES } from "./routines";
import { TESTING } from "./testing";
import { TRAVEL_HELP_DESK } from "./travel-help-desk";
import { YOUR_EDITOR } from "./your-editor";
import { YOUR_TOOLS } from "./your-tools";

/** The guides, in the order a reader takes them (T13b; the plan's 39-t13-the-front-door.md numbers them). */
export const GUIDES: readonly Guide[] = [
  TRAVEL_HELP_DESK,
  YOUR_TOOLS,
  APPROVALS,
  INSIDE_YOUR_APP,
  TESTING,
  EVENTS_AND_WEBHOOKS,
  MANY_CUSTOMERS,
  ROUTINES,
  YOUR_EDITOR,
  GOING_LIVE,
];
